import App from './Player/App.svelte';
// const socket = io();
const app = new App({
    target: document.body,
});

export default app;
